import axios from 'axios';
import { PositionGroupLogRequest, PositionGroupLog } from '../schemas/PositionGroupLog.schema';

export function retrievePositionGroupLog(params: PositionGroupLogRequest) {
    return axios.get<PositionGroupLog>('/v1/log/position-group', {
        params,
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('WF_APPLICATION')
        }
    });
}
